import { cn } from '../../../utils/string/cn.utils';

const SelectionBasic = ({ label, actived, onClick, ...props }) => {
  return (
    <div
      className={cn(
        'flex py-[8px] px-[12px] justify-center items-center gap-[10px] rounded-[4px] bg-fills-primary border-[1px] border-solid border-transparent cursor-pointer hover:bg-primary-primaryFill',
        actived ? 'bg-primary-primaryFill border-outline-brand-primary' : '',
        props.className
      )}
      onClick={onClick}
    >
      <span className="text-label-medium">{label}</span>
    </div>
  );
};
export default SelectionBasic;
